import React, { useEffect, useState } from 'react';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';
import CardContainer from 'components/Tvendo/Common/CardContainer';
import ReactTable from 'components/ReactTable/ReactTable';
import { Add, Visibility } from '@material-ui/icons';
import { Link, useNavigate } from 'react-router-dom';
import { wsGetAll } from 'services/WService';

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 75 },
  { Header: 'Estado', accessor: 'state_migrate', width: 120 },
  { Header: 'Proveedor', accessor: 'CardName' },
  { Header: 'Documento', accessor: 'document', width: 120 },
  { Header: 'Referencia', accessor: 'purchase', width: 120 },
  { Header: 'Total', accessor: 'DocTotal', width: 150 },
  { Header: 'Fecha creación', accessor: 'created_at', width: 150 },
  { Header: 'Fecha documento', accessor: 'TaxDate', width: 170 },
  { Header: 'Fecha contable', accessor: 'DocDate', width: 170 },
  { Header: 'Fecha vencimiento', accessor: 'DocDueDate', width: 170 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

function PurchaseCreditNoteList() {
  const navigate = useNavigate();
  const [creditNotes, setCreditNotes] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);

  async function listCreditNotes() {
    setDataLoading(true);
    let res = await wsGetAll('purch/credit-note');
    setDataLoading(false);
    if (res.success) {
      setCreditNotes(res.data);
    }
  }

  useEffect(() => {
    listCreditNotes();
  }, []);

  return (
    <CardContainer /*title="Notas de crédito compras"*/ title={(<>Notas de crédito compras {dataLoading && <LoadingSpinner />}</>)} icon={<Add />} onClick={() => {
      navigate('0');
    }}>
      <ReactTable
        columns={columns}
        formatDate="DD-MM-YYYY"
        data={creditNotes.map((creditNote, index) => {
          let state_migrate = creditNote.state_migrate;
          switch (creditNote.state_migrate) {
            case 'D':
              state_migrate = 'Borrador';
              break;
            case 'V':
              state_migrate = 'Validado';
              break;
            case 'X':
              state_migrate = 'Procesando...';
              break;
            case 'P':
            case 'Y':
              state_migrate = 'Procesado';
              break;
          }
          return {
            num: (
              <div className="actions-right">
                {index + 1}
                <Link to={`${creditNote.id}`}>
                  <Visibility />
                </Link>
              </div>
            ),
            state_migrate,
            CardName: creditNote.provider.CardName,
            document: `${creditNote.U_SYP_MDSD}-${creditNote.U_SYP_MDCD}`,
            purchase: `${creditNote.U_SYP_MDSO}-${creditNote.U_SYP_MDCO}`,
            DocTotal: creditNote.DocTotal,
            created_at: creditNote.created_at,
            TaxDate: creditNote.TaxDate,
            DocDate: creditNote.DocDate,
            DocDueDate: creditNote.DocDueDate,
          };
        })}
      />
    </CardContainer>
  );
}

export default PurchaseCreditNoteList;
